import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CartSummary from '../subscription/components/CartSummary';
import CheckoutForm from '../subscription/components/CheckoutForm';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/common/Button';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import {API} from "aws-amplify";
import useSnack from "hooks/useSnack";
import Divider from '../../checkout/components/CustomDivider';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB);

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    paddingTop: 16,
    paddingBottom: 16,
  },
  btn: {
    paddingLeft: 50,
    paddingRight: 50,
  },
  card: {
    boxShadow: 'none',
    backgroundColor: '#F8F9FC',
    width: '100%',
  },
  cardBody: {
    '& h5': {
      display: 'none',
    },
  },
  field: {
    marginBottom: theme.spacing(1),
  },
  checkoutForm: {
    backgroundColor: '#FFECE4',
    maxWidth: 620,
    padding: theme.spacing(3),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(4)
  }
}));

const Payment = ({ customer, product, onSubmit, setStep, onChange, data }) => {
  const classes = useStyles();
  const [showCard, setShowCard] = useState(!customer);
  const existingCard = customer?.sources.data[0];
  const [coupon, setCoupon] = useState();
  const snack = useSnack();

  const onCouponChange = (e) => {
    onChange({
      ...data,
      coupon: e.target.value,
    });
  };

  const onSubmitCoupon = () => {
    return API.post('public', `/stripe/coupons/verify`, {
      body: { coupon: data.coupon, product: product.stripe_product_id },
    }).then(
      (resp) => {
        if (!resp) {
          snack.error('Invalid coupon code');
          onChange({
            ...data,
            coupon: '',
          });
        } else if (resp.valid) {
          snack.success('Coupon code successfully applied!');
        }
        setCoupon(resp);
      },
      (e) => {
        snack.error(e.response.data.message);
      },
    );
  };


  return (
    <Box margin="auto" maxWidth={{ md: '70%' }}>
      <Typography align="center" variant="h5">Plan info</Typography>
      <Box marginTop={5}>
        <CartSummary
          plan={product}
          couponCode={data.coupon}
          coupon={coupon}
          onCouponChange={onCouponChange}
          onSubmitCoupon={onSubmitCoupon}
        />
        { product.service_details && (
          <Box marginTop={3}>
            <div className="rich-text-content" dangerouslySetInnerHTML={{__html: product.service_details }} />
          </Box>
        )}
      </Box>
      <Box marginTop={3}>
        {showCard ? (
            <Box className={classes.checkoutForm}>
              <Divider />
              <Elements stripe={stripePromise}>
                <CheckoutForm onToken={onSubmit} />
              </Elements>
            </Box>
        ) : (
          <Box>
            <Typography variant="subtitle1">
              Paying Using {existingCard.brand} {existingCard.last4}{' '}
              <a href="#" onClick={() => setShowCard(true)}>
                Change
              </a>
            </Typography>
            <br />
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => onSubmit()}
            >
              Submit Payment
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Payment;
